import 'construct-style-sheets-polyfill'; const styleSheet = new CSSStyleSheet(); styleSheet.replaceSync(`:host {
    font-family: var(--inv-font-family, 'Inter');
    font-size: var(--inv-input-checkbox-font-size, 1em);
}

.form-control {
    font-family: var(--inv-font-family, 'Inter');
    font-size: 0.6em;
    display: grid;
    grid-template-columns: 1em auto;
    gap: 0.4em;
}

input[type='checkbox'] {
    appearance: none;
    background-color: #fff;
    margin: 0;
    font: inherit;
    color: currentColor;
    width: 1em;
    height: 1em;
    border: 0.08333em solid var(--inv-input-checkbox-border-color, #548de3);
    border-radius: 0.33333em;
    display: grid;
    place-content: center;
}

input[type='checkbox']::before {
    content: '';
    width: 0.66666em;
    height: 0.66666em;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em var(--inv-input-checkbox-box-shadow-color, #548de3);
    transform-origin: bottom left;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
}

input[type='checkbox']:checked::before {
    transform: scale(1);
}
`); export default styleSheet;